import Divider from '../../misc/Divider/Divider';
import RepositionExtraInfo from '../RepositionExtraInfo/RepositionExtraInfo';
import RepositionPriceInputs from '../RepositionPriceInputs/RepositionPriceInputs';
import styles from './RepositionAdvancedMode.module.css';
const RepositionAdvancedMode = () => {
  return (
    <div className={styles.advanced_mode_container}>
      <RepositionPriceInputs />
      <Divider/>
      <RepositionExtraInfo />
    </div>
  );
};

export default RepositionAdvancedMode;
